import { useEffect, useState } from 'react';
import { ativarPush, enviarTeste, garantirInscricaoNoServidor, situacaoPush, type SituacaoPush } from '../lib/push.js';
import { useEhCelular } from '../lib/tela.js';
import { useToast } from './ui.js';

const CHAVE_ADIADO = 'gl.avisos.adiadoAte';

function adiado(): boolean {
  try {
    return Number(localStorage.getItem(CHAVE_ADIADO) ?? 0) > Date.now();
  } catch {
    return false;
  }
}

/**
 * Faixa no topo do painel enquanto ESTE aparelho não recebe avisos.
 *
 * Pedido do Guel (06/10/2026): "só chega notificação quando tá aberto". A
 * ativação existia, escondida em Configurações › Notificações — e em 07/10
 * nenhum aparelho tinha ativado. Aqui fica à vista, um clique, em cada
 * computador e celular, até a pessoa ativar ou dizer "agora não".
 */
export function AtivarAvisos() {
  const ehCelular = useEhCelular();
  const toast = useToast();
  const [situacao, setSituacao] = useState<SituacaoPush | null>(null);
  const [ocupado, setOcupado] = useState(false);
  const [escondido, setEscondido] = useState(adiado());

  useEffect(() => {
    void situacaoPush()
      .then((s) => {
        setSituacao(s);
        if (s.estado === 'ativo') void garantirInscricaoNoServidor().catch(() => undefined);
      })
      .catch(() => undefined);
  }, []);

  if (!situacao || escondido) return null;
  const aparelho = ehCelular ? 'neste celular' : 'neste computador';

  if (situacao.estado === 'negado') {
    return (
      <div className="faixa-avisos negado" role="status">
        <span>
          Os avisos estão <strong>bloqueados</strong> {aparelho}. Clique no cadeado ao lado do endereço do site, permita
          <strong> Notificações</strong> e recarregue a página.
        </span>
        <button type="button" className="small" onClick={() => esconder(setEscondido)}>
          Fechar
        </button>
      </div>
    );
  }
  if (situacao.estado !== 'disponivel') return null;

  return (
    <div className="faixa-avisos" role="status">
      <span>
        Ative os avisos {aparelho}: cliente novo e conversa esperando a equipe tocam aqui{' '}
        <strong>mesmo com o painel fechado</strong>.
      </span>
      <div className="row" style={{ gap: 8 }}>
        <button
          type="button"
          className="primary small"
          disabled={ocupado}
          onClick={async () => {
            setOcupado(true);
            try {
              const nova = await ativarPush();
              setSituacao(nova);
              if (nova.estado === 'ativo') {
                await enviarTeste().catch(() => undefined);
                toast('Avisos ativados. Mandamos um aviso de teste para este aparelho.');
              }
            } catch (erro) {
              toast((erro as Error).message);
            } finally {
              setOcupado(false);
            }
          }}
        >
          {ocupado ? 'Ativando…' : 'Ativar avisos'}
        </button>
        <button type="button" className="small" onClick={() => esconder(setEscondido)}>
          Agora não
        </button>
      </div>
    </div>
  );
}

function esconder(setEscondido: (v: boolean) => void) {
  try {
    // Volta a lembrar em 3 dias: aviso desligado é cliente esperando sem ninguém saber.
    localStorage.setItem(CHAVE_ADIADO, String(Date.now() + 3 * 86_400_000));
  } catch {
    /* sem armazenamento: some só nesta sessão */
  }
  setEscondido(true);
}
